import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { SvgIconSwipable } from '../../assets/SvgIconSwipable';

export interface MeasurementProps {
  children: React.ReactNode;
}

export function Measurement({ children }: MeasurementProps) {
  return <Wrapper>{children}</Wrapper>;
}

const Wrapper = styled.div`
  width: 100%;
`;

const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 0 32px 0;
`;

const Image = styled.img`
  width: 241px;
  height: 241px;
  object-fit: contain;
`;

const GuideText = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  margin: -28px 0 10px;

  & > p {
    color: ${vars.v3Color.gray500};
    margin: 0 5px 0 0;
  }
`;

const HorizontalSwipeIcon = styled(SvgIconSwipable)`
  width: 32px;
  height: 10px;
  object-fit: cover;
`;

const OverflowableTable = styled.div`
  width: 100%;
  overflow: auto;
  display: flex;
  flex-shrink: 0;
`;

const Description = styled.div`
  display: flex;
  align-items: start;
  gap: 2px;
`;

Measurement.ImageArea = ImageWrapper;
Measurement.Image = Image;
Measurement.GuideText = GuideText;
Measurement.SwiperIcon = HorizontalSwipeIcon;
Measurement.Table = OverflowableTable;
Measurement.Description = Description;
